<div class="relative">
    <button class="text-secondary close-button" mat-dialog-close mat-icon-button type="button">
        <mat-icon [icIcon]="icClose"></mat-icon>
    </button>    
</div>

<mat-dialog-content class="-my-4 subscription">
    <vex-billing [preferredPackageIndex$]="preferredPackageIndex$"></vex-billing>
</mat-dialog-content>

